import React, { useState, useEffect } from 'react';
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import {GrNext} from "react-icons/gr";
import {useSelector} from "react-redux";

const SaveOnInfo = ({saveOnFolio}) => {

    const { email } = useSelector(state => state.repository.user);
    const [value, setValue] = useState(saveOnFolio);

    const handleInputChange = () => {
        setValue(value)
    }

    useEffect(() => {
        setValue(saveOnFolio);
    }, [saveOnFolio]);


    return (
        <>
            <label htmlFor="profile-form-contract">Save On Resort Num.:</label>
            <div className="input-group mb-3">

                <input type="text"
                       id="value"
                       name="value"
                       value={value}
                       onChange={handleInputChange}
                       className="form-control not-dark"
                />
                <div className="input-group-append">
                    <button className="button button-3d button-black nomargin" type="button"
                            id="button-addon2"
                    >CREATE
                    </button>
                </div>
            </div>

            <Accordion defaultActiveKey="0">
                <Card className="nomargin nopadding">
                    <Card.Header className="nomargin nopadding">
                        <Accordion.Toggle as={Card.Header} variant="link" eventKey="1">
                            <GrNext /> Save On Resort Detail
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="1" >
                        <Card.Body>
                            <div className="contract-info">
                                <div className="row">
                                    <div className="col_full nomargin nopadding">
                                        <div className="col_full divcenter">
                                            <label htmlFor="profile-form-save-on-email">User Email:</label>
                                            <input type="text"
                                                   id="email"
                                                   name="email"
                                                   value={email}
                                                   readOnly
                                                   className="form-control not-dark"/>
                                        </div>

                                        <div className="col_full divcenter">
                                            <label htmlFor="profile-form-save-on-password">User Password:</label>
                                            <input type="password"
                                                   id="password"
                                                   name="password"
                                                   value={email}
                                                   readOnly
                                                   className="form-control not-dark"/>
                                        </div>

                                        <div className="col_full divcenter">
                                            <button className="button button-3d button-black btn-block nomargin" type="button"
                                                    id="save-on-button"
                                            >Create Save On Resort
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </>
    );
};

export default SaveOnInfo;
